import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme, { isCardsHidden }: { isCardsHidden: boolean }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.other.spacing._32,
    gap: theme.other.spacing._24,

    maxWidth: '400px',
  },

  headerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    color: theme.colors.gray[9],
    fontWeight: 700,
  },

  description: {
    color: theme.colors.gray[7],
    fontWeight: 500,
  },

  actionButton: {
    width: '100%',
  },

  arrowContainer: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: theme.colors.gray[1],
    border: '4px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
  },

  welcomeHeaderContainer: {
    position: 'relative',
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ isCardsHidden ? '0px' : '100px',
  },

  badgeSection: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },

  cardSection: {
    position: 'absolute',
    top: '50px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '230px',
    zIndex: 10,
  },

  comboBadgeContainer: {
    position: 'relative',
    width: '60px',
    height: '60px',
  },

  comboBadgeOFP: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
  },

  comboBadgeRYP: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    zIndex: 2,
  },

  topCard: {
    position: 'relative',
    zIndex: 13,
  },

  middleCard: {
    position: 'absolute',
    top: '20px',
    left: '10px',
    right: '10px',
    zIndex: 12,
  },

  bottomCard: {
    position: 'absolute',
    top: '40px',
    left: '20px',
    right: '20px',
    zIndex: 11,
  },

  mockupCard: {
    backgroundColor: 'white',
  },

  mockupGroup: {
    width: '100%',
  },

  mockupAvatarContainer: {
    position: 'relative',
  },

  mockupAvatar: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    backgroundColor: theme.colors.gray[1],
  },

  mockupBadge: {
    position: 'absolute',
    bottom: -1,
    right: -1,
    zIndex: 1,
  },

  mockupContent: {
    flex: 1,
  },

  mockupTitleBar: {
    height: 14,
    width: '100%',
    backgroundColor: theme.colors.gray[1],
    borderRadius: theme.radius.xs,
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 3,
  },

  mockupMetadataContainer: {
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ 3,
    alignItems: 'center',
    width: '100%',
  },

  mockupMetadataBar: {
    height: 7,
    width: '25%',
    backgroundColor: theme.colors.gray[1],
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 1.5,
  },
}));

export default useStyles;
